module.exports = ".checkbox input[type=checkbox]:checked + .icon-kyc { \r\n    color: var(--icon-color); \r\n}\r\n.checkbox .checkbox-inline span.active { \r\n    color: var(--icon-color); \r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/common/kid/kid.component.css
// module id = ./src/app/shared/common/kid/kid.component.css
// module chunks = main